<template>
  <div :id="idModal" :class="`modal ${isAtivo ? 'is-active' : ''}`">
    <div class="modal-background" @click="isFecharComBackground? $emit('close') : ''"></div>
    <div class="modal-card" :class="`${isModalPersonalizado ? 'modal-card-personalizado' : ''}`">
      <slot name="modal-header">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ titulo }}</p>
            <button
            v-if="isFecharComX"
            id="btn-fechar-modal"
            class="delete ml-3"
            aria-label="close"
            data-cy="btn-fechar-modal"
            @click="$emit('close')"
            ></button>
        </header>
      </slot>
      <section class="modal-card-body" :style="customStyleBody" :class="`${isScrollPersonalizado ? 'scroll-personalizado' : ''}`">
        <slot />
      </section>
      <footer class="modal-card-foot">
        <slot name="slot-footer">
            <button class="button" @click="$emit('close')">
            Fechar
            </button>
        </slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfSimpleModal",
  props: {
    titulo: String,
    isAtivo: {
      type: Boolean,
      default: true,
    },
    isFecharComBackground: {
        type: Boolean,
        default: false,
    },
    isFecharComX: {
        type: Boolean,
        default: true,
    },
    idModal: String,
    isModalPersonalizado: {
      type: Boolean,
      default: false
    },
    customStyleBody: String,
    isScrollPersonalizado: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card-head {
  padding: 15px 15px 15px 35px;
}

.modal-card-title {
  font-size: 18px;
  line-height: 1.42857143;
}

.modal-card-body {
  padding: 8px 28px;
}

.modal-card-foot {
  justify-content: flex-end;
  padding: 15px;
}
.modal-card.modal-card-personalizado .modal-card-body{
    width: auto;
    padding: 0;
    overflow:hidden;
}
@media screen and (min-width: 769px){
 .modal-card.modal-card-personalizado{
    width: auto;
    padding: 0;
 }
}

.modal-card-body.scroll-personalizado{
    scrollbar-width: thin;
    scrollbar-color: #969696 #dbdbdb;
   &::-webkit-scrollbar  {
    width: 6px;
    height: 5px;
    @media screen and (max-width: 768px) {
      width: 2px;
    }
  }
  &::-webkit-scrollbar-track {
    background: #dbdbdb;
    border-radius: 9px;
    margin: 0px 0;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #969696;
    border-radius: 11px;
    border: 0px none #969696;
  }
}
</style>
